PJQ.TokenManager = class {
	UPDATE_EVENT = 'TOKENS_UPDATED';

	constructor(options = {}) {
		this.Key_Access_Token = 'access_token';
		this.Key_Refresh_Token = 'refresh_token';

		this.enabled = options && options.enabled === true;
		this.setAccessToken(options.accessToken);
		this.setRefreshToken(options.refreshToken);

		if (this.enabled) {
			this.addBroadcastChannelListener();
		}
	}

	addBroadcastChannelListener() {
		this.bc = new BroadcastChannel('TOKEN_CHANNEL');
		this.bc.addEventListener("message", _.bind(function (event) {
			if (event.data != null) {
				this.setAccessToken(event.data.accessToken);
				this.setRefreshToken(event.data.refreshToken);
			}
		}, this));
	}

	setAccessToken(accessToken) {
		window.sessionStorage.removeItem(this.Key_Access_Token);
		if (_.size(accessToken) > 0) {
			window.sessionStorage.setItem(this.Key_Access_Token, accessToken);
		}
	}

	setRefreshToken(refreshToken) {
		window.sessionStorage.removeItem(this.Key_Refresh_Token);
		if (_.size(refreshToken)) {
			window.sessionStorage.setItem(this.Key_Refresh_Token, refreshToken);
		}
	}

	updateTokens(accessToken, refreshToken, opts = {}) {
		this.setAccessToken(accessToken);
		this.setRefreshToken(refreshToken);

		if (opts.expiresOn != null) {
			this.updateCookies(opts.expiresOn, opts.onCookiesUpdated, opts.cookieParams);
		}

		if (opts.broadcast !== false) {
			new BroadcastChannel('TOKEN_CHANNEL').postMessage({
				accessToken: this.getAccessToken(),
				refreshToken: this.getRefreshToken()
			});
		}
	}

	updateCookies(expiresOn, callback, params = []) {
		let accessToken = this.getAccessToken(),
			refreshToken = this.getRefreshToken();
		if (_.size(refreshToken) > 0 && _.size(accessToken) > 0 && expiresOn != null) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: PJQ.app.options.isK8 ? 'token' : 'Token.ashx'
					}
				], _.union(params, [
					{
						parameter: 'r',
						value: refreshToken
					},
					{
						parameter: 'a',
						value: accessToken
					},
					{
						parameter: 'exp',
						value: expiresOn
					}
				])),
				isOrigin: true
			}).get().done(_.bind(function () {
				if (typeof callback === 'function') {
					callback(true);
				}
			}, this)).fail(_.bind(function () {
				if (typeof callback === 'function') {
					callback(false);
				}
			}, this));
		}
	}

	getRefreshToken() {
		return window.sessionStorage.getItem(this.Key_Refresh_Token);
	}

	getAccessToken() {
		return window.sessionStorage.getItem(this.Key_Access_Token);
	}

	getTokensForAccessKey(accessKey, callback) {
		return this.getTokensForUser(null, null, callback, {accessKey: accessKey});
	}

	getTokensForUser(username, password, callback, options = {}) {
		let cb = function (success, error) {
			if (typeof callback === 'function') {
				callback(success != null ? success : false, error != null ? error : null);
			}
		}

		let params;
		if (_.size(options.accessKey) > 0) {
			if (_.size(this.getAccessToken()) > 0 && this.accessKey === options.accessKey) {
				cb(true);
				return;
			}

			this.accessKey = options.accessKey;
			params = [
				{
					parameter: 'accessKey',
					value: options.accessKey
				}
			];
		} else {
			params = [
				{
					parameter: 'username',
					value: username
				},
				{
					parameter: 'password',
					value: password
				}
			];
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'token'
				}
			], params),
			isAPIv2: true
		}).post().done(_.bind(function (data) {
			if (_.size(data.access_token) > 0) {
				this.updateTokens(data.access_token, data.refresh_token);
				let headers = {
					Authorization: "Bearer " + data.access_token
				};
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'token'
						},
						{
							endpoint: 'signin'
						}
					]),
					headers: headers
				}).get().done(_.bind(function (sessionData) {
					if (sessionData.success) {
						this.updateTokens(data.access_token, data.refresh_token, {
							expiresOn: PJQ.helpers.dateHelpers.getNewDateAddSeconds(new Date(), 300),
							cookieParams: [
								{
									parameter: 'dnn',
									value: sessionData.cookie
								},
								{
									parameter: 's',
									value: sessionData.sessionId
								}
							],
							onCookiesUpdated: _.bind(function () {
								cb(true);
							}, this)
						});
					} else {
						cb(true, 'CUSTOMER_SERVICE');
					}
				}, this));
			} else {
				cb(false, _.size(data.error) > 0 ? data.error : 'CUSTOMER_SERVICE');
			}
		}, this)).fail(_.bind(function (data) {
			cb(false, _.size(data.error) > 0 ? data.error : 'CUSTOMER_SERVICE');
		}, this));
	}

	refreshAccessToken(callback) {
		let refreshToken = this.getRefreshToken();
		if (_.size(refreshToken) > 0) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'token'
					}
				], [
					{
						parameter: 'refresh_token',
						value: refreshToken
					}
				]),
				isAPIv2: true,
				canAuthRetry: false
			}).post().done(_.bind(function (data) {
				if (_.size(data.access_token) > 0) {
					this.updateTokens(data.access_token, data.refresh_token, {
						expiresOn: PJQ.helpers.dateHelpers.getNewDateAddSeconds(new Date(), data.expires_in),
						onCookiesUpdated: _.bind(function () {
							if (typeof callback === 'function') {
								callback(this.getAccessToken());
							}
						}, this)
					});
				} else if (typeof callback === 'function') {
					callback(this.getAccessToken());
				}
			}, this)).fail(_.bind(function () {
				this.handleUnauthorized();
			}, this));
		} else {
			this.handleUnauthorized();
		}
	}

	handleUnauthorized() {
		if (PJQ.app.options.isK8) {
			window.location.href = "/signout";
		} else {
			window.location.href = "/Signout.aspx?r=" + encodeURIComponent(window.location.origin + '/#signin');
		}
	}
};